// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Selectors
import { isDebugToolbarEnabledSelector, isDebugEnabledSelector } from './debugStateSelector';

// Components
import LoadableDebugToolbar from './LoadableDebugToolbar';
import useBodyClass from '../utils/react/useBodyClass';

const mapStateToProps = (state) => ({
    debugToolbarEnabled: isDebugEnabledSelector(state) && isDebugToolbarEnabledSelector(state),
});

const DebugToolbarContainer = (props) => {
    const { debugToolbarEnabled } = props;

    useBodyClass(debugToolbarEnabled ? 'debug-toolbar-enabled' : '');

    if (!debugToolbarEnabled) return null;

    return <LoadableDebugToolbar {...props} />;
};

DebugToolbarContainer.propTypes = {
    debugToolbarEnabled: PropTypes.bool,
};

export default connect(mapStateToProps)(DebugToolbarContainer);
